import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import * as queryString from "query-string";

import { LoadingOutlined } from "@ant-design/icons";

import { getCustomerBalance } from "../../api";

import WalletActiveAccount from "./WalletActiveAccount";
import WalletOverview from "./WalletOverview";
import WalletDeposit from "./WalletDeposit";
import WalletPaymentConfirmation from "./WalletPaymentConfirmation";
import WalletBankTransfer from "./WalletBankTransfer";
import WalletBankTransferPending from "./WalletBankTransferPending";
import { Spin } from "antd";

const Wallet = () => {
  const { search } = useLocation();
  const parseQuery = queryString.parse(search);
  // let defaultView = "overview";

  // if (parseQuery && parseQuery.type) {
  //   defaultView = String(parseQuery.type);
  // }

  const { t } = useTranslation(["common", "notification"]);
  const [viewType, setViewType] = useState<string>('overview');
  const [customerWallet, setCustomerWallet] = useState<any>({});
  const [walletLoading, setWalletLoading] = useState<boolean>(false);
  console.log("viewType", viewType);
  //
  // useEffect(() => {
  //   window.addEventListener('message', function(e) {
  //     // e.data hold the message from child
  //     console.log(e.data);
  //   } , false);
  // }, [])

  useEffect(() => {
    const parseQuery = queryString.parse(search);
    if (parseQuery?.type && parseQuery.type !== viewType) {
      setViewType(String(parseQuery.type));
    }
  }, [search]);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setWalletLoading(true);

    // Balance info
    const customerBalance = await getCustomerBalance();

    setCustomerWallet(customerBalance.data);
    setWalletLoading(false);
  };

  const handleChangeView = (view: string) => {
    setViewType(view);
    if (view === "overview") {
      fetchData();
    }
  };

  // Embed
  function cancelEmbed() {
    const message = JSON.stringify({
      type: "deposit",
      cancel: true,
      success: false,
    });
    window.parent.postMessage(message, "*");
  }

  // REDNERING
  if (walletLoading) {
    return (
      <Spin
        size="large"
        indicator={<LoadingOutlined spin />}
        style={{ width: "100%" }}
      />
    );
  }

  if (viewType === "activeAccount") {
    return (
      <WalletActiveAccount
        handleChangeView={handleChangeView}
        fetchCustomerWallet={fetchData}
      />
    );
  }

  if (viewType === "deposit") {
    return (
      <WalletDeposit
        handleChangeView={handleChangeView}
        cancelEmbed={cancelEmbed}
      />
    );
  }

  if (viewType === "paymentConfirmation") {
    return (
      <WalletPaymentConfirmation
        handleChangeView={handleChangeView}
        cancelEmbed={cancelEmbed}
      />
    );
  }

  if (viewType === "bankTransfer") {
    return (
      <WalletBankTransfer
        handleChangeView={handleChangeView}
        cancelEmbed={cancelEmbed}
      />
    );
  }

  if (viewType === "bankTransferPending") {
    return (
      <WalletBankTransferPending
        handleChangeView={handleChangeView}
        cancelEmbed={cancelEmbed}
      />
    );
  }

  return (
    <WalletOverview
      customerWallet={customerWallet}
      handleChangeView={handleChangeView}
    />
  );
};

export default Wallet;
